import React, { useEffect, useRef } from "react";
import { SWIREPAY_URL } from "../../appconstants";
import ErrorPage from "../../components/error";
import { SwirepayGooglePay, SwirepayApplePay } from '@swirepay-developer/swirepay-payment-sdk';

const Error = () => {

  const googlePayRef = useRef(null);
  const applePayRef = useRef(null);

  useEffect(() => {
    window.swirepayPayableAmount = 100;
    const accountInfo = {
      accountGid: 'account-96f23f2964654c1abf85a7965b120be0',
      apiKey: 'pk_live_nz8qMkpsM6CgO2evAtloysG6Ydv1mwz0',
    };
    googlePayRef.current = new SwirepayGooglePay({
      mountId: 'swirepay-google-pay-root',
      unMountOnError: true,
      accountGid: accountInfo.accountGid,
      apiKey: accountInfo.apiKey,
      test: false,
      currencyCode: 'USD',
      countryAlpha2: 'US',
      countryCallingCode: '+1',
      processStartCallback: () => {
        console.log('google pay process started');
        // showLoader();
      },
      successCallback: (data) => {
        console.log(data, 'Sucess Response');
        // hideLoader();
        // alert('Google Pay Payment was Successful');
        // showStatusModal('success', 'Google Pay Payment was Successful');
      },
      failCallback: (data) => {
        console.log(data, 'Failed Response');
        // hideLoader();
        // alert('Google Pay based payment was unsuccessful');
        // showStatusModal('error', 'Google Pay based payment was unsuccessful');
      },
    });
    applePayRef.current = new SwirepayApplePay({
      mountId: 'swirepay-apple-pay-root',
      unMountOnError: true,
      accountGid: accountInfo.accountGid,
      apiKey: accountInfo.apiKey,
      currencyCode: "USD",
      countryAlpha2: "US",
      test: false,
      shopName: 'My Shop',
      processStartCallback: () => {
        console.log('apple pay process started');
        // showLoader();
      },
      successCallback: (data) => {
        console.log(data, 'Sucess Response');
        // hideLoader();
        // showStatusModal('success', 'Apple Pay Payment was Successful');
      },
      failCallback: (data) => {
        // hideLoader();
        // alert(data);
        // showStatusModal('error', data || 'Apple Pay payment failed');
        console.log(data, 'Failed Response');
      },
    });
    return () => {
      // cleanup on component unmount
      googlePayRef.current?.removeAllChildFromMount();
      googlePayRef.current = null;
      applePayRef.current?.removeAllChildFromMount();
      applePayRef.current = null;
    };
  }, []);
  return (
    <>
      <ErrorPage
        heading={'Oops!'}
        body={'Invalid url. Make sure the URL is correct and try again.'}
        url={SWIREPAY_URL}
      />
      {/* <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <div id="swirepay-apple-pay-root"></div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <div id="swirepay-google-pay-root"></div>
      </div> */}
    </>
  )
};

export default Error;
